import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_DATE_TIME_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'
import { getScheduleChangeStopDateTime, parseScheduleChangeDateTime } from 'lib/flights/scheduleChangePresentation'

interface Props {
  stop: App.FlightScheduleChangeHiddenStop
}

function ScheduleChangeIntermediateStopDetails({ stop }: Props) {
  const intl = useIntl()
  const arrivalValue = getScheduleChangeStopDateTime(stop, 'arrival')
  const departureValue = getScheduleChangeStopDateTime(stop, 'departure')
  const arrival = arrivalValue && intlDateFormatter(parseScheduleChangeDateTime(arrivalValue), INTL_DATE_TIME_FORMAT, intl.locale, 'UTC')
  const departure = departureValue && intlDateFormatter(parseScheduleChangeDateTime(departureValue), INTL_DATE_TIME_FORMAT, intl.locale, 'UTC')
  let text: string
  if (arrival && departure) {
    text = intl.formatMessage({
      id: 'rKADXHFUNNO3n2nWai1b',
      defaultMessage: 'Stop at {airport}: arrives {arrival}, departs {departure}.',
      description: 'Captured arrival and departure at an intermediate stop inside one flight in schedule change details',
    }, { airport: stop.airportCode, arrival, departure })
  } else if (arrival) {
    text = intl.formatMessage({
      id: 'Kuz6xhmeiKYUXVeySGfi',
      defaultMessage: 'Stop at {airport}: arrives {arrival}.',
      description: 'Captured arrival at an intermediate stop when its departure time is unavailable in schedule change details',
    }, { airport: stop.airportCode, arrival })
  } else if (departure) {
    text = intl.formatMessage({
      id: 'AMG2VhSXzT4eR3D6oOT2',
      defaultMessage: 'Stop at {airport}: departs {departure}.',
      description: 'Captured departure from an intermediate stop when its arrival time is unavailable in schedule change details',
    }, { airport: stop.airportCode, departure })
  } else {
    text = intl.formatMessage({
      id: 'm0PzrqFUVitfbcQGPOJ_',
      defaultMessage: 'Stop at {airport}',
      description: 'Intermediate airport stop within a flight in the schedule change details modal',
    }, { airport: stop.airportCode })
  }
  return <BodyText variant="medium">{text}</BodyText>
}

export default ScheduleChangeIntermediateStopDetails
